import { apiGetAllStores } from "../../api/apiGetAllStores";
import { apiGetBookingInfo } from "../../api/apiGetBookingInfo";
import { storeGetSetup, storeSelect } from "./store";
import { bookingProcessSelectDate, bookingProcessSelectTime, promotionSelect, personalDataSetFields, setIsEditingBooking, bookingProcessSetPeople } from "./bookingProcess";
import { DEFAULT_COUNTRY_DATA, EDIT_BOOKING_STEPS } from "../../constants";

export const EDIT_BOOKING_SET_VALUES = 'EDIT_BOOKING_SET_VALUES';
export const editBookingSetValues = ({ bookingCode, restaurantName }) => ({
    type: EDIT_BOOKING_SET_VALUES, bookingCode, restaurantName
});

// ============ GET STORE LIST
export const EDIT_BOOKING_START_STORE_LIST = 'EDIT_BOOKING_START_STORE_LIST';
export const editBookingStartStoreList = () => ({ type: EDIT_BOOKING_START_STORE_LIST });

export const EDIT_BOOKING_ERROR_STORE_LIST = 'EDIT_BOOKING_ERROR_STORE_LIST';
export const editBookingErrorStoreList = () => ({ type: EDIT_BOOKING_ERROR_STORE_LIST });

export const EDIT_BOOKING_SET_STORE_LIST = 'EDIT_BOOKING_SET_STORE_LIST';
export const editBookingSetStoreList = stores => ({ type: EDIT_BOOKING_SET_STORE_LIST, stores });

export const EDIT_BOOKING_SELECT_STORE = 'EDIT_BOOKING_SELECT_STORE';
export const editBookingSelectStore = store => ({ type: EDIT_BOOKING_SELECT_STORE, store });

export const editBookingRequestStoreList = () => async (dispatch, getState) => {
    const { editBookingState } = getState();
    if (editBookingState.storesList && editBookingState.storesList.length > 0) {
        return;
    }

    dispatch(editBookingStartStoreList());
    try {
        const stores = (await apiGetAllStores()).map(store => ({ id: store.id, code: store.code, name: store.name }));
        dispatch(editBookingSetStoreList(stores));
        return stores;
    } catch (error) {
        console.log(error);
        dispatch(editBookingErrorStoreList());
        throw error;
    }
}

export const EDIT_BOOKING_SET_STEP = 'EDIT_BOOKING_SET_STEP';
export const editBookingSetStep = editStep => ({ type: EDIT_BOOKING_SET_STEP, editStep });

// ============ GET INFO BOOKING
export const EDIT_BOOKING_START_GET_INFO_BOOKING = 'EDIT_BOOKING_START_GET_INFO_BOOKING';
export const editBookingStartGetInfoBooking = () => ({ type: EDIT_BOOKING_START_GET_INFO_BOOKING });

export const EDIT_BOOKING_ERROR_GET_INFO_BOOKING = 'EDIT_BOOKING_ERROR_GET_INFO_BOOKING';
export const editBookingErrorGetInfoBooking = () => ({ type: EDIT_BOOKING_ERROR_GET_INFO_BOOKING });

export const EDIT_BOOKING_SET_BOOKING_INFO = 'EDIT_BOOKING_SET_BOOKING_INFO';
export const editBookingSetBookingInfo = booking => ({ type: EDIT_BOOKING_SET_BOOKING_INFO, booking });

export const editBookingGetBooking = ({ bookingCode, restaurantName, restaurantId }) => async (dispatch, getState) => {
    // If none of the params are populated return the default search view
    if (!(bookingCode && (restaurantId || restaurantName))) {
        dispatch(editBookingRequestStoreList());
        return dispatch(editBookingSetStep(EDIT_BOOKING_STEPS.SEARCH_BOOKING));
    } else {
        dispatch(editBookingSetStep(EDIT_BOOKING_STEPS.SHOW_BOOKING));
    }

    dispatch(editBookingStartGetInfoBooking());

    // Retrieve the store list
    const { editBookingState } = getState();
    let stores = [];
    if (editBookingState.storesList && editBookingState.storesList.length > 0) {
        stores = editBookingState.storesList;
    } else {
        try {
            stores = await dispatch(editBookingRequestStoreList());
        } catch (error) {
            console.log(error);
            return dispatch(editBookingSetStep(EDIT_BOOKING_STEPS.SEARCH_BOOKING));
        }
    }

    // Search the store list to find the restaurantName
    let store = null;
    if (restaurantId) {
        store = stores.find(s => s.id === restaurantId);
    } else {
        store = stores.find(s => s.code.toUpperCase().indexOf(restaurantName.toUpperCase()) !== -1);
    }

    if (!store) {
        dispatch(editBookingSetStep(EDIT_BOOKING_STEPS.SEARCH_BOOKING));
        return dispatch(editBookingErrorGetInfoBooking());
    }
    dispatch(editBookingSelectStore(store));

    // Retrieve the booking info
    let bookingInfo = {};
    try {
        bookingInfo = await apiGetBookingInfo({ storeId: store.id, bookingCode: bookingCode });

        if (bookingInfo.DepositPaidAmount > 0) {
            console.log('Payment made, can edit set to false')
            bookingInfo.CanEdit = false;
        }
    } catch (error) {
        console.log(error);
        dispatch(editBookingSetStep(EDIT_BOOKING_STEPS.SEARCH_BOOKING));
        return dispatch(editBookingErrorGetInfoBooking());
    }
    dispatch(editBookingSetBookingInfo(bookingInfo));
}

// ============ EDIT CLICKED
export const editBookingPopulateFlow = (history) => async (dispatch, getState) => {
    const { editBookingState } = getState();
    dispatch(storeSelect(editBookingState.selectedStore.id));
    await dispatch(storeGetSetup(editBookingState.selectedStore.id));
    dispatch(bookingProcessSetPeople(editBookingState.bookingInfo.PartySize));
    dispatch(bookingProcessSelectDate(editBookingState.bookingInfo.VisitDate));
    dispatch(bookingProcessSelectTime(editBookingState.bookingInfo.VisitTime));
    dispatch(promotionSelect(editBookingState.bookingInfo.PromotionId));

    const customer = editBookingState.bookingInfo.Customer;
    customer.MobileCountryCode = customer.MobileCountryCode ? customer.MobileCountryCode.toString() : '39';

    const allCountryData = window.intlTelInputGlobals.getCountryData();
    const countryData = allCountryData.find(c => c.dialCode === customer.MobileCountryCode) || { ...DEFAULT_COUNTRY_DATA };
    dispatch(personalDataSetFields({
        name: customer.FirstName,
        surname: customer.Surname,
        mobilePhone: customer.Mobile,
        email: customer.Email,
        hasAcceptedEmailMarketing: customer.ReceiveEmailMarketing,
        specialRequests: customer.SpecialRequests,
        mobilePhoneCountryData: countryData,
        specialRequests: editBookingState.bookingInfo.SpecialRequests,
    }));
    dispatch(setIsEditingBooking(true));
    history.replace('/persone');
}

export const EDIT_BOOKING_RESET = 'EDIT_BOOKING_RESET';
export const editBookingResetAction = () => {
    console.log('Reset edit state action');
    return { type: EDIT_BOOKING_RESET };
}

export const editBookingReset = () => dispatch => {
    console.log('Reset edit state');
    dispatch(setIsEditingBooking(false));
    dispatch(editBookingResetAction());
}


// WEBPACK FOOTER //
// ./src/store/actions/editBooking.js